import React from 'react';
import { Star } from '../Icons';
import PropTypes from 'prop-types';

const StarList = ({ count, className }) => {
	const renderStars = () => {
		return [...Array(count).keys()].map(i => <Star key={i} />);
	};

	return <div className={className}>{renderStars()}</div>;
};

export default StarList;

StarList.defaultProps = {
	className: 'stars-container',
	count: 1
};

StarList.propTypes = {
	className: PropTypes.string,
	count: PropTypes.number.isRequired
};
